$(function () {
  /**
   * Měření kliků na pás „Přidejte si Businessinfo.cz mezi oblíbené zdroje na Googlu".
   *
   * V GTM musí existovat trigger typu Custom Event na `bi_google_follow_click`
   * a navázaný GA4 Event tag — jinak push jen leží v dataLayer.
   */
  $('body').on('click', '.bi-google-strip__btn', function () {
    window.biTrackEvent('bi_google_follow_click', {
      bi_post_id: parseInt($(this).data('post-id'), 10) || 0,
      bi_content_type: $('body').data('cpt'),
    });
  });

  function logVisit(visit) {
    let searchParams = new URLSearchParams(window.location.search);

    searchParams.delete('pg');
    let savedUrl = window.location.pathname + '?' + searchParams.toString();

    if (typeof (sessionStorage) !== 'undefined' && !visit) {
      let searchedUrls = sessionStorage.searchedUrls;

      if (searchedUrls) {
        searchedUrls = $.parseJSON(searchedUrls);

        if ($.inArray(savedUrl, searchedUrls) > -1) {
          return;
        }

        searchedUrls.push(savedUrl);
      } else {
        searchedUrls = [];
        searchedUrls.push(savedUrl);
      }

      sessionStorage.searchedUrls = JSON.stringify(searchedUrls);
    }

    if (visit) {
      $.ajax({
        method: 'POST',
        url: '/wp-admin/admin-post.php',
        data: {
          post: $('input[name="visit-post"]').val(),
          nonce: $('input[name="visit-nonce"]').val(),
          action: 'visit-detail',
        },
      });
    } else {
      $.ajax({
        method: 'POST',
        url: '/wp-admin/admin-post.php',
        data: {
          url: window.location.href,
          nonce: $('input[name="search-nonce"]').val(),
          action: 'search-vertical',
        },
      });
    }
  }

  let visit = $('#visit-post').length ? parseInt($('#visit-post').val()) : -1;
  visit = visit > -1 ? visit : $('#search-vertical').length ? 0 : -1;

  if (visit > -1) {
    let botPattern = '(googlebot/|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)';
    let re = new RegExp(botPattern, 'i');
    let userAgent = navigator.userAgent;

    if (!re.test(userAgent)) {
      let moved = false;

      $(document).on('mousemove', function () {
        if (!moved) {
          setTimeout(function () {
            logVisit(visit);
          }, 1000);
        }

        moved = true;
      });

      $('body').on('touchmove', function () {
        if (!moved) {
          setTimeout(function () {
            logVisit(visit);
          }, 1000);
        }

        moved = true;
      });

      $(window).on('scroll', function () {
        if (!moved) {
          setTimeout(function () {
            logVisit(visit);
          }, 1000);
        }

        moved = true;
      });
    }
  }

  /**
   * Měření interakcí — GA4 přes dataLayer (viz window.biTrackEvent ve functions.php).
   *
   * Do 2025-12-01 to jelo přes window.__gaTracker (shim pluginu MonsterInsights Pro).
   * Commit d955b0b350 plugin smazal, globál zmizel a celý blok byl obalený podmínkou
   * `typeof window.__gaTracker !== 'undefined'` — takže se od té doby ani nezaregistroval
   * a všechny události tiše zmizely. Detail: docs/tracking/ga4-events.md.
   *
   * Parametry: `dimension1/2/3` z Universal Analytics nahrazeny pojmenovanými
   * (bi_content_type / bi_position / bi_taxonomy). Nově se posílá i cíl odkazu
   * (bi_link_url, bi_link_text) — dosud se `link` jen zahazoval do event_callbacku.
   * `event_callback` odpadá: navigaci nikdy nic nebrzdilo (chybí preventDefault)
   * a GA4 odesílá přes sendBeacon, který přežije odchod ze stránky.
   */
  function linkInfo($el) {
    return {
      bi_link_url: $el.prop('href') || '',
      bi_link_text: ($el.text() || '').replace(/\s+/g, ' ').trim().slice(0, 100),
    };
  }

  // click_lists / click_detail_other zrušeny 2026-08-31. Mířily na
  // `.related-content__wrapper`, což je třída, která v repozitáři nikdy
  // neexistovala. Související obsah na detailu měří click_detail_related,
  // pravý sloupec vertikály měří list_right_col_*. Rozbor: docs/tracking/ga4-events.md § 3.

  // Stránkování. Původní `.related-content__wrapper .more` neexistovalo; stránkování
  // souvisejícího obsahu v tom smyslu na portálu není. Přemapováno 2026-08-31 na
  // skutečné prvky: „Zobrazit více" u výpisu vertikály (article-list.php:63,95)
  // a stránkování souvisejících článků v pravém widgetu (lazyload.js:1214).
  $('body.single-vertical, body.home').on('click', 'a.js-load-more', function () {
    window.biTrackEvent('click_pagination_lists', {
      bi_content_type: $('body').data('cpt') || 'homepage',
    });
  });

  $('body.single:not(.single-vertical)').on('click', '.gx-right-widget .more-articles .more', function () {
    window.biTrackEvent('click_pagination_detail', {
      bi_content_type: $('body').data('cpt'),
    });
  });

  $('body.single').on('click', '.related-articles__wrapper article a', function () {
    window.biTrackEvent('click_detail_related', Object.assign({
      bi_content_type: $('body').data('cpt'),
      bi_position: $(this).parent('article').prevAll('article').length + 1,
    }, linkInfo($(this))));
  });

  $('body.single').on('click', '.taxonomy-theme a:not(.more), section.taxonomy a', function () {
    var taxonomy = $(this).closest('.taxonomy-theme').length
      ? $(this).parent().parent().parent().find('[data-theme]').data('theme')
      : $(this).parent().data('taxonomy');

    window.biTrackEvent('click_filter_taxonomy_detail', Object.assign({
      bi_content_type: $('body').data('cpt'),
      bi_taxonomy: taxonomy,
    }, linkInfo($(this))));
  });

  // Tlačítko „Další X v kategoriích" má třídu `more-articles-button`, ne `more`
  // (opportunity-header.php:103, event-header.php:105, legislation-header.php:131).
  $('body.single').on('click', '.article-detail-info a.more-articles-button', function () {
    window.biTrackEvent('click_more_categories', Object.assign({
      bi_content_type: $('body').data('cpt'),
    }, linkInfo($(this))));
  });

  // Checkboxy filtru se renderují z localStorage v lazyload.js:161-188. Slug taxonomie
  // nese `<li data-parent>`, slug termu samotný input. Původní `.filter__body
  // label.checkbox` ani `.category-list[data-group]` v repozitáři neexistují.
  $('body.single-vertical').on('change', 'input.js-filter-checkbox', function () {
    window.biTrackEvent('click_filter_taxonomy_lists', {
      bi_content_type: $('body').data('cpt'),
      bi_taxonomy: $(this).closest('li').data('parent'),
      bi_term: $(this).data('term-slug'),
      bi_checked: $(this).is(':checked'),
    });
  });

  $('body').on('click', '.most-filtered a[data-taxonomy]', function () {
    window.biTrackEvent('click_most_filtered', Object.assign({
      bi_content_type: $('body').data('cpt'),
      bi_taxonomy: $(this).data('taxonomy'),
    }, linkInfo($(this))));
  });

  $('body').on('click', '.hp-recommended article a', function () {
    window.biTrackEvent('hp_recommended', Object.assign({
      bi_position: $(this).parent('article').prevAll('article').length + 1,
    }, linkInfo($(this))));
  });

  // Mobilní i desktopová varianta slideru používají stejné třídy (homepage.php:52 a 211),
  // takže `.hp-video-slider a` pokrývá obě. Původní druhý selektor `hp-mobile-video-slider a`
  // byl mrtvý — chyběla tečka a taková třída v repozitáři není.
  $('body').on('click', '.hp-video-slider a', function () {
    // Audio varianta slideru má na wrapperu třídu .audio (homepage.php:74).
    // Bez tohoto rozlišení by audio kliky padaly pod hp_video_slider.
    var isAudio = $(this).closest('.hp-video-slider').hasClass('audio');

    window.biTrackEvent(isAudio ? 'hp_audio_slider' : 'hp_video_slider', linkInfo($(this)));
  });

  $('html').on('click', 'body.single-vertical .article-right-column .right-col-slider-item a', function () {
    // Audio položky mají .audio přímo na .right-col-slider-item (lazyload.js:252).
    var isAudio = $(this).closest('.right-col-slider-item').hasClass('audio');

    window.biTrackEvent(isAudio ? 'list_right_col_audio_slider' : 'list_right_col_video_slider', Object.assign({
      bi_content_type: $('body').data('cpt'),
    }, linkInfo($(this))));
  });

  $('html').on('click', 'body.single:not(.single-vertical) .article-right-column .js-article-right-slider a', function () {
    var isAudio = $(this).closest('.right-col-slider-item').hasClass('audio');

    window.biTrackEvent(isAudio ? 'detail_right_col_audio_slider' : 'detail_right_col_video_slider', Object.assign({
      bi_content_type: $('body').data('cpt'),
    }, linkInfo($(this))));
  });

  /**
   * Události, na které GTM čekal, ale nikdy je nikdo neposílal.
   * Doplněno 2026-07-31 — soupis a rozbor v docs/tracking/ga4-events.md § 3.
   */

  // Řazení výsledků hledání (template-parts/shared/search-header.php).
  // Rozlišení podle query parametrů cílového odkazu: sort=relevance |
  // sort=date&ord=desc (nejnovější) | sort=date&ord=asc (nejstarší).
  $('body').on('click', '.filter--result-sorting a', function () {
    var href = $(this).prop('href') || '';
    var name;

    if (href.indexOf('sort=relevance') !== -1) {
      name = 'click_sort_relevance';
    } else if (href.indexOf('ord=asc') !== -1) {
      name = 'click_sort_oldest';
    } else {
      name = 'click_sort_newest';
    }

    window.biTrackEvent(name, {
      bi_content_type: $('body').data('cpt'),
    });
  });

  // Otevření kategorií filtru. Zavírání má vlastní .js-filter-terms-button-close,
  // takže tohle tlačítko znamená vždy „otevřít".
  $('body').on('click', '.js-filter-terms-button', function () {
    window.biTrackEvent('filter_menu_open', {
      bi_content_type: $('body').data('cpt'),
    });
  });

  // „Použít filtr" (page-filter-sticky.php).
  $('body').on('click', '.js-filter-done', function () {
    window.biTrackEvent('filter_apply', {
      bi_content_type: $('body').data('cpt'),
      bi_filter_keyword: $('.js-filter-search-input').filter(function () {
        return $(this).val();
      }).first().val() || '',
    });
  });

  // Klíčové slovo filtru — na `change`, tedy jednou po dopsání, ne po každé klávese.
  $('body').on('change', '.js-filter-search-input', function () {
    window.biTrackEvent('filter_search_input', {
      bi_content_type: $('body').data('cpt'),
      bi_filter_keyword: $(this).val() || '',
    });
  });

  // Globální vyhledávání v hlavičce. Odesílá se na submit (pokryje Enter i klik
  // na lupu), název události je převzatý z existujícího GTM triggeru.
  $('body').on('submit', 'form', function () {
    var $q = $(this).find('input[name="q"]');

    if (!$q.length) {
      return;
    }

    window.biTrackEvent('search_global_click', {
      bi_content_type: $('body').data('cpt'),
      bi_search_query: ($q.val() || '').toString().trim().slice(0, 100),
    });
  });
});
